import dayjs, {Dayjs} from 'dayjs'

export const SQL_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DISPLAY_DATE_TIME_FORMAT = 'D MMMM YYYY HH:mm:ss'
export const DISPLAY_DATE_FORMAT = 'D MMMM YYYY'

export function displayTime(sqlDateTime?: string): string {
    if (sqlDateTime == null) {
        return ''
    }
    return dayjs.utc(sqlDateTime, SQL_DATE_TIME_FORMAT).local().format(DISPLAY_DATE_TIME_FORMAT)
}

export function displayAgo(sqlDateTime?: string, omitSuffix = false): string {
    if (sqlDateTime == null) {
        return ''
    }
    return dayjs.utc(sqlDateTime, SQL_DATE_TIME_FORMAT).local().fromNow(omitSuffix)
}

export function toDate(dateString: string, format: string) {
    return dayjs.utc(dateString, format).toDate()
}

export function setMidnight(day: Dayjs) {
    day.set('hours', 0).set('minutes', 0).set('seconds', 0)
    return day
}